module.exports = __webpack_public_path__ + "static/media/gsod_practiceRanking1.7d7715a0.svg";